import React, { useState, useEffect } from 'react'
import './HeaderStyles.css'
import flogb from '../../assets/images/flo-gb.svg'
import logo from '../../assets/images/logo.png'
import LanguageIcon from '../../assets/images/Language.svg'
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
import MenuOutlinedIcon from '@mui/icons-material/MenuOutlined';
import { useDispatch } from 'react-redux';
import { logout } from '../../redux/userSlice'
import { useNavigate } from 'react-router-dom'
import SelectLanguage from '../Commons/SelectLanguage'
import Cookies from 'js-cookie'
import { useTranslation } from 'react-i18next';



const HeaderSection = () => {
    const [isSticky, setSticky] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate()
    const { t } = useTranslation();
    const handleLogout = () => {
        dispatch(logout());
        Cookies.remove('userDetails', { path: '' });
        navigate('login')
        // Additional actions after dispatching logout can go here
    };

    const handleMyProfile = () => {
        navigate('/my-profile');
    }

    const handleScroll = () => {
        setSticky(window.scrollY > 0);
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <div>
            <div className="flo-bg">
                <div className="inn-bg">
                    <img src={flogb} className="img-fluid"  alt='Header Logo'/>
                </div>
            </div>
            <header id="header" className={`fixed-top mb-2 ${isSticky ? 'header-scrolled' : ''}`}>
                {/* <header id="header" className="sticky-top mb-2"> */}
                <div className="container-fluid ">
                    <div className="d-flex align-items-center border-bottom inner-header">
                        <a href="index.html" className="logo me-auto"><img src={logo} alt="" className="img-fluid" /></a>
                        <nav id="navbar1" className="navbar1">
                            <ul>
                                {/* <li className="dropdown cly-btn">
                                    <img src={LanguageIcon} className="img-fluid" /> */}
                                <li>
                                    <SelectLanguage />
                                    {/* <a href="#"><span>
                                </span> English <i className="bi bi-chevron-down"></i></a>
                                    <ul>
                                        <li><a href="#">Hindi</a></li>
                                    </ul> */}
                                </li>
                                <li className="ms-3">
                                    <a className="nav-link scrollto icon-clay p-0" href="#">
                                        <span className="inner-clay hea-ft position-relative"><div className="dot"></div><NotificationsNoneOutlinedIcon /></span>
                                    </a>
                                </li>
                                <li className="dropdown ms-3">
                                    <a className="nav-link scrollto icon-clay p-0" href="#"><span className="inner-clay hea-ft"><i><PersonOutlineOutlinedIcon style={{ color: 'black' }} /></i></span></a>
                                    <ul>
                                        <li><button onClick={handleMyProfile}>{t('headers.myProfile')}</button></li>
                                        <li><button>{t('headers.changePassword')}</button></li>
                                        <li><button onClick={handleLogout}>{t('headers.logOut')}</button></li>
                                    </ul>
                                </li>
                                <li>
                                    <button className="navbar-toggler navbar-toggler-right d-lg-none align-self-center" type="button" > 
                                    {/* dataToggle="offcanvas" */}
                                        <span>
                                            <MenuOutlinedIcon />
                                        </span>
                                    </button>
                                </li>
                            </ul>
                        </nav>
                    </div>


                </div>
            </header>
            {/* <!-- End Header --> */}

        </div>
    )
}

export default HeaderSection
